export default __webpack_public_path__ + "static/frame2-8f10964c9201caa77318fc4d0e63382f.png";